import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type DocumentOwnerKind, documentKeys } from '@/entities/document'
import { apiRequest } from '@/shared/api'
import type { FileRef } from '@/shared/lib'

export interface CreateDocumentVars {
  slot_id: string
  title: string
  file: FileRef
  note?: string
}

// Новый документ в слоте (первая версия + файл). Владелец выводится бэком из
// slot_id. Сотрудник заводит черновик, заказчик — сразу видимый (решает бэк).
export function useCreateDocument(entityKind: DocumentOwnerKind, entityId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: CreateDocumentVars) =>
      apiRequest<{ id: string }>({
        method: 'POST',
        url: '/documents',
        body: { ...vars },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: documentKeys.byEntity(entityKind, entityId) })
    },
  })
}
